import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { Card } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Card";
export const CardService = {
	endpoint,
	createSingle: async (data: Card) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getByFixture: async (fixtureId: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetByFixture/${fixtureId}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getLatest: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetLatest`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Card) => await Service.updateSingleById(endpoint, id, data),
}